import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import RegisterPage from "@/pages/RegisterPage.vue";
import userList from "@/pages/UserList.vue";
import createPage from "@/pages/CreatePage.vue";
import customerPage from "@/pages/CustomerPage.vue";
import billPage from "@/pages/BillPage.vue";
import notificationPage from "@/pages/NotificationPage.vue";
import statisticalPage from "@/pages/StatisticalPage.vue";
import inputPage from "@/pages/InputPage.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '',
    component: Home,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    props: true
  },
  {
    path: '/userList',
    name: 'userList',
    component: userList,
    props: true
  },
  {
    path: '/createPage',
    name: 'createPage',
    component: createPage,
    props: true
  },
  {
    path: '/customerPage',
    name: 'customerPage',
    component: customerPage,
    props: true
  },
  {
    path: '/billPage',
    name: 'billPage',
    component: billPage,
    props: true
  },
  {
    path: '/notificationPage',
    name: 'notificationPage',
    component: notificationPage,
    props: true
  },
  {
    path: '/statisticalPage',
    name: 'statisticalPage',
    component: statisticalPage,
    props: true
  },
  {
    path: '/inputPage',
    name: 'inputPage',
    component: inputPage,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
